"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var apps_shared_1 = require("@l2p/apps-shared");
var ProfileMenuList_1 = __importDefault(require("../ProfileMenuList"));
var Languages_1 = __importDefault(require("../Languages"));
var common_hooks_1 = require("@l2p/common-hooks");
var swr_hooks_1 = require("@l2p/swr-hooks");
var UnAuthProfileMenu = function (_a) {
    var languages = _a.languages, defaultCurrency = _a.defaultCurrency, firstDepMaxBonus = _a.firstDepMaxBonus, firstDepFreespins = _a.firstDepFreespins, WelcomeProfileBanner = _a.WelcomeProfileBanner, promoLink = _a.promoLink;
    var openSignIn = (0, apps_shared_1.useOpenSignIn)();
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var openManager = (0, common_hooks_1.usePremiumSupport)().openManager;
    var config = (0, swr_hooks_1.useConfig)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var tLang = (0, next_intl_1.useTranslations)('languages');
    var lang = (0, next_intl_1.useLocale)();
    var secondaryMenuList = (0, react_1.useMemo)(function () {
        var defaultList = [
            {
                label: t('bonuses'),
                icon: '/img/profileMenu/megaphone.svg',
                href: generateUrlWithLang('/promotions'),
            },
            {
                label: t('payments'),
                icon: '/img/profileMenu/bank.svg',
                href: generateUrlWithLang('/payments'),
            },
            {
                label: t('tournaments'),
                icon: '/img/profileMenu/tournaments.svg',
                href: generateUrlWithLang('/tournaments'),
            },
            {
                label: t('vipclub'),
                icon: '/img/profileMenu/vip.svg',
                href: generateUrlWithLang('/vip'),
            },
        ];
        return promoLink
            ? __spreadArray([
                {
                    label: t('promo'),
                    icon: '/img/promo/bonusIcon.svg',
                    href: generateUrlWithLang(promoLink),
                }
            ], defaultList, true) : defaultList;
    }, [promoLink, t, generateUrlWithLang]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        WelcomeProfileBanner ? (react_1.default.createElement(WelcomeProfileBanner, null)) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bannerText, dangerouslySetInnerHTML: {
                    __html: t('grabYourBonus', {
                        bonus: "".concat(firstDepMaxBonus, " ").concat(defaultCurrency),
                        freespins: firstDepFreespins,
                    }),
                } }),
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", width: "200px", text: "upper", onClick: openSignUp }, t('signup')))),
        react_1.default.createElement(ProfileMenuList_1.default, { items: (config === null || config === void 0 ? void 0 : config.liveChatShouldDisabled)
                ? [
                    {
                        label: tLang(lang),
                        icon: '/img/profileMenu/globe.svg',
                        dropdown: react_1.default.createElement(Languages_1.default, { languages: languages }),
                    },
                ]
                : [
                    {
                        label: t('supportChat'),
                        icon: '/img/profileMenu/chat.svg',
                        onClick: openManager,
                    },
                    {
                        label: tLang(lang),
                        icon: '/img/profileMenu/globe.svg',
                        dropdown: react_1.default.createElement(Languages_1.default, { languages: languages }),
                    },
                ] }),
        react_1.default.createElement(ProfileMenuList_1.default, { secondary: true, items: secondaryMenuList }),
        react_1.default.createElement(ProfileMenuList_1.default, { items: [
                {
                    label: t('login'),
                    icon: '/img/profileMenu/signIn.svg',
                    onClick: openSignIn,
                },
            ] })));
};
exports.default = UnAuthProfileMenu;
